import { useCallback } from 'react';
import type { Nullable } from 'corgi-types';

import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';

const enum EventName {
  CardGridView = 'card-grid_view',
  CardGridClick = 'card-grid_click',
}

export const useTrackingEvents = (listPosition: number, title: Nullable<string>) => {
  const cardTitle = title ?? '';

  const onImageView = useCallback(() => {
    dispatchTrackingEventGA4({
      event: EventName.CardGridView,
      element: 'image',
      title: cardTitle,
      list_position: listPosition,
    });
  }, [cardTitle, listPosition]);

  const onImageClick = useCallback(() => {
    dispatchTrackingEventGA4({
      event: EventName.CardGridClick,
      element: 'image',
      title: cardTitle,
      list_position: listPosition,
    });
  }, [cardTitle, listPosition]);

  return { onImageView, onImageClick };
};
